module.exports = __webpack_public_path__ + "static/media/pause_stream_img.251c713e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pause_stream_img.svg
// module id = 661
// module chunks = 7